import { render, staticRenderFns } from "./WholesaleOrders.vue?vue&type=template&id=531274ac&scoped=true&"
import script from "./WholesaleOrders.vue?vue&type=script&lang=js&"
export * from "./WholesaleOrders.vue?vue&type=script&lang=js&"
import style0 from "./WholesaleOrders.vue?vue&type=style&index=0&id=531274ac&prod&lang=css&"
import style1 from "./WholesaleOrders.vue?vue&type=style&index=1&id=531274ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531274ac",
  null
  
)

export default component.exports